function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* eslint-disable jsx-a11y/no-autofocus */

import React, { useEffect, useContext } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import DayPicker, { DateUtils } from 'react-day-picker';
import { Button } from '../../../Button';
import { PLACEMENT_TOP_LEFT, PLACEMENT_TOP_RIGHT, PLACEMENT_BOTTOM_RIGHT, PLACEMENT_BOTTOM_LEFT } from '../../../Utils/constant';
import { DatepickerContext } from '../../context';
import { getDateString, localeUtils } from '../../utils/helper';
import DatepickerInput from '../Input';
import DatepickerNavigation from '../Navigation';
function SingleSelectPanel(props) {
  const {
    trigger,
    className,
    errorMessage,
    setErrorMessage,
    disabledDays,
    numberOfMonths,
    showOutsideDays,
    selectedDays,
    validateInputDate,
    clearAction,
    confirmAction,
    disableConfirmButton,
    handleSingleSelectionDayClick,
    placement,
    ...restProps
  } = props;
  const {
    locale,
    isOpen,
    month,
    dateFormat,
    handleOnClose,
    withInput,
    handleResetClick,
    datepickerContainerRef,
    setDisableConfirmButton,
    datepickerTriggerRef
  } = useContext(DatepickerContext);
  useEffect(() => {
    if (selectedDays && !errorMessage) {
      setDisableConfirmButton(false);
    } else {
      setDisableConfirmButton(true);
    }
  }, [selectedDays, errorMessage]);
  useEffect(() => {
    document.addEventListener('click', handleDocumentClick);
    return () => {
      document.removeEventListener('click', handleDocumentClick);
    };
  }, [isOpen, trigger]);
  const handleDocumentClick = event => {
    var _datepickerContainerR, _datepickerTriggerRef;
    if (isOpen && !(datepickerContainerRef !== null && datepickerContainerRef !== void 0 && (_datepickerContainerR = datepickerContainerRef.current) !== null && _datepickerContainerR !== void 0 && _datepickerContainerR.contains(event.target)) && !(datepickerTriggerRef !== null && datepickerTriggerRef !== void 0 && (_datepickerTriggerRef = datepickerTriggerRef.current) !== null && _datepickerTriggerRef !== void 0 && _datepickerTriggerRef.contains(event.target)) && !Array.from(event.target.classList).includes('DayPicker-Day')) {
      errorMessage && handleResetClick();
      handleOnClose(event);
    }
  };
  const onDayClick = function (day) {
    let config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let event = arguments.length > 2 ? arguments[2] : undefined;
    handleSingleSelectionDayClick(day, {
      ...config,
      DateUtils
    }, event);
  };
  const handleSubmit = event => {
    validateInputDate(event);
  };
  if (!isOpen) return '';
  const datepickerPlacementClasses = classNames({
    'sib-datepicker-panel': true,
    [PLACEMENT_TOP_LEFT]: placement === 'topLeft',
    [PLACEMENT_TOP_RIGHT]: placement === 'topRight',
    [PLACEMENT_BOTTOM_RIGHT]: placement === 'bottomRight',
    [PLACEMENT_BOTTOM_LEFT]: placement === 'bottomLeft'
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: datepickerPlacementClasses,
    ref: datepickerContainerRef
  }, withInput && /*#__PURE__*/React.createElement("div", {
    className: "datepicker-input--single-select"
  }, /*#__PURE__*/React.createElement(DatepickerInput, {
    autoFocus: true,
    isFocused: true,
    dateFormat: dateFormat,
    onSubmit: handleSubmit,
    isError: !!errorMessage,
    setIsError: () => setErrorMessage(''),
    specificationText: errorMessage,
    selectedDate: selectedDays && getDateString(selectedDays, dateFormat)
  })), /*#__PURE__*/React.createElement(DayPicker, _extends({}, restProps, {
    fixedWeeks: true,
    month: month,
    locale: locale,
    format: dateFormat,
    onDayClick: onDayClick,
    selectedDays: selectedDays,
    disabledDays: disabledDays,
    localeUtils: localeUtils,
    numberOfMonths: numberOfMonths,
    showOutsideDays: showOutsideDays,
    navbarElement: DatepickerNavigation,
    className: `SingleDatePicker ${className}`
  })), /*#__PURE__*/React.createElement("div", {
    className: "sib-datepicker-action"
  }, /*#__PURE__*/React.createElement("div", {
    className: "action--left"
  }, /*#__PURE__*/React.createElement(Button, clearAction)), /*#__PURE__*/React.createElement("div", {
    className: "action--right"
  }, /*#__PURE__*/React.createElement(Button, _extends({}, confirmAction, {
    disabled: disableConfirmButton
  }))))));
}
SingleSelectPanel.propTypes = {
  trigger: PropTypes.bool,
  className: PropTypes.string,
  errorMessage: PropTypes.string.isRequired,
  setErrorMessage: PropTypes.func.isRequired,
  selectedDays: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.array, PropTypes.string, PropTypes.func, PropTypes.instanceOf(Date)]),
  validateInputDate: PropTypes.func.isRequired,
  clearAction: PropTypes.object.isRequired,
  confirmAction: PropTypes.object.isRequired,
  disableConfirmButton: PropTypes.bool.isRequired,
  handleSingleSelectionDayClick: PropTypes.func.isRequired,
  numberOfMonths: PropTypes.number,
  showOutsideDays: PropTypes.bool,
  disabledDays: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.array, PropTypes.func, PropTypes.instanceOf(Date)]),
  placement: PropTypes.string
};
SingleSelectPanel.defaultProps = {
  trigger: true,
  className: '',
  errorMessage: '',
  selectedDays: '',
  disabledDays: [],
  clearAction: {},
  confirmAction: {},
  numberOfMonths: 1,
  showOutsideDays: true,
  setErrorMessage: () => {},
  validateInputDate: () => {},
  disableConfirmButton: false,
  handleSingleSelectionDayClick: () => {},
  placement: ''
};
export default SingleSelectPanel;